// The API also returns an absolute mediaUrl, but that is built from the server's
// public origin — pointing at production while developing locally. The stored key
// resolves against whatever host the POS is being served from.
export function getImageSrc(mediaLink) {
  return mediaLink ? `/api/uploads/${mediaLink}` : null;
}

// The first image is the cover: the API returns them ordered by displayOrder.
export function coverOf(product) {
  return product?.images?.[0] || null;
}
